import React from "react";
import "./News.css";

function News() {
  return (
    <div>
      <div className="backDrop">
        <div class="newsframe">
          <iframe
            src="https://rss.app/embed/v1/wall/tywNsW1rmFujWEJD"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default News;
